import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';

interface GuestCommentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: {
    firstName: string;
    lastName: string;
    email: string;
  }) => void;
  loading?: boolean;
}

const GuestCommentModal: React.FC<GuestCommentModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  loading = false
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      console.error('Form validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      centered
      title="Guest Comment"
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={handleSubmit}
          loading={loading}
        >
          Submit Comment
        </Button>
      ]}
      width={400}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="firstName"
          label="First Name"
          rules={[
            { required: true, message: 'First name is required.' }
          ]}
        >
          <Input 
            prefix={<UserOutlined />} 
            placeholder="Enter your first name"
          />
        </Form.Item>

        <Form.Item
          name="lastName"
          label="Last Name"
          rules={[
            { required: true, message: 'Last name is required.' }
          ]}
        >
          <Input 
            prefix={<UserOutlined />} 
            placeholder="Enter your last name"
          />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Email is required.' },
            { type: 'email', message: 'Please enter a valid email address.' }
          ]}
        >
          <Input 
            prefix={<MailOutlined />} 
            placeholder="Enter your email address"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GuestCommentModal; 